import { Injectable } from '@angular/core';
import { ApiResponse } from 'src/AngularJS/Models/api-response.model';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { ModuleManagerExportFormat } from 'src/shared/models/module-manager/module-manager-options.model';
import { ExpandedSummaryData, ExpandedSummaryGroups } from './expanded-summary.model';

@Injectable({
    providedIn: 'root'
})
export class ExpandedSummaryService {
    constructor(
        private cvApiService: CVApiService, // Inject not needed, since it's already written in TypeScript
    ) { }

    public async getSettings(moduleKey: string): Promise<ExpandedSummaryGroups> {
        let renderEndpoint: string;
        try {
            renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
        } catch (err) {
            console.error("Failed getting module render endpoint");
            throw err;
        }

        try {
            const url = `/api/v2/dashboards/modules/expanded-summary/${encodeURIComponent(moduleKey)}/settings`;
            const response = await this.cvApiService.get<ExpandedSummaryGroups>(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (err) {
            console.error("Failed getting settings for expanded summary module");
            throw err;
        }
    }

    public async getData(moduleKey: string, isAutoRefresh: boolean = false, isFirstLoad: boolean = false, abort: Promise<void>): Promise<ExpandedSummaryData> {
        let renderEndpoint: string;
        try {
            renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
        } catch (err) {
            console.error("Failed getting module render endpoint");
            throw err;
        }

        try {
            const url = "/api/v2/dashboards/modules/expanded-summary/" + encodeURIComponent(moduleKey) +
                "?isAutoRefresh=" + isAutoRefresh + "&isFirstLoad=" + isFirstLoad;
            const response = await this.cvApiService.get<ExpandedSummaryData>(url, renderEndpoint, abort);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (err) {
            if (!(err instanceof DOMException && err.name == "AbortError"))
                console.error("Failed getting data for expanded summary module");
            throw err;
        }
    }

    /** Get data from API endpoint for expanded summary data formatted for export */
    public async getExport(
        moduleKey: string,
        format: ModuleManagerExportFormat = ModuleManagerExportFormat.Excel
    ): Promise<ApiResponse<string>> {
        let renderEndpoint: string;
        try {
            renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
        } catch (err) {
            console.error("Failed getting module render endpoint");
            throw err;
        }

        try {
            const url = "/api/v2/dashboards/modules/expanded-summary/" + encodeURIComponent(moduleKey)
                + "/export?format=" + encodeURIComponent(format);
            const response = await this.cvApiService.get<string>(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        } catch (err) {
            console.error("Failed getting data to export expanded summary module");
            throw err;
        }
    }
}
